module.exports = "pegasus/assets/blue-ghost-twitter.png";